import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const Disclaimer = () => (
  <div className="min-h-screen bg-[#050505]">
    <Navbar />
    <section className="pt-28 pb-16">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <h1 className="text-3xl font-black font-heading text-white mb-8">Disclaimer</h1>
        <div className="prose prose-invert prose-zinc max-w-none space-y-6 text-sm text-zinc-400 leading-relaxed">
          <h2 className="text-xl font-bold text-white mt-8">General Disclaimer</h2>
          <p>AYRONN Funding operates a simulated trading evaluation platform. We are not a broker, financial institution, or investment firm. Our services consist solely of evaluating trading performance in a simulated environment.</p>
          <h2 className="text-xl font-bold text-white mt-8">No Guarantees</h2>
          <p>We do not guarantee any specific outcomes, profits, or rewards. Performance-based rewards are contingent upon meeting all evaluation criteria and compliance with platform rules.</p>
          <h2 className="text-xl font-bold text-white mt-8">Third-Party Services</h2>
          <p>Our platform utilizes third-party technology providers for trading infrastructure. AYRONN Funding is not responsible for any technical issues, outages, or disruptions caused by third-party services.</p>
          <h2 className="text-xl font-bold text-white mt-8">Content Accuracy</h2>
          <p>While we strive to provide accurate information, AYRONN Funding makes no warranties regarding the accuracy, completeness, or reliability of any content on this platform.</p>
          <h2 className="text-xl font-bold text-white mt-8">Jurisdiction</h2>
          <p>Users are responsible for ensuring compliance with local laws and regulations. AYRONN Funding does not provide services in jurisdictions where such services are prohibited.</p>
          <h2 className="text-xl font-bold text-white mt-8">Limitation of Liability</h2>
          <p>To the maximum extent permitted by law, AYRONN Funding shall not be liable for any indirect, incidental, special, or consequential damages arising from the use of our services.</p>
        </div>
      </div>
    </section>
    <Footer />
  </div>
);

export default Disclaimer;
